import update from '../api/updateDatabase'
import globalNotification from 'live/services/global-notification'
import getModels from '../api/getModels'

export default function updateDatabase(database) {
    return (dispatch, getState) => {
        update(database)
            .then(data => {
                globalNotification.success(`Database successfully edited.`)
                getModels().then(models => {
                    dispatch({
                        type: 'UPDATE_DATABASE_MODELS',
                        models: models
                    })
                })
            })
            .catch(err => {
                globalNotification.error(`Database couldn't be edited.`)
                err.response.json().then(({ error }) => {
                    console.error('Error updating database:', error)
                    dispatch({
                        type: 'UPDATE_SHEET_ERROR',
                        updateErrorMessage: error
                    })
                })
            })
    }
}
